import {
  Button,
  Container,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  Box,
  Checkbox,
  FormControl,
  InputLabel,
  TextareaAutosize,
} from "@mui/material";

import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import { cloneDeep, range, uniq } from "lodash";
import "react-virtualized/styles.css"; // only needs to be imported once
import cogoToast from "cogo-toast";
import { Upload } from "src/components/upload";

class BotCreator extends React.Component {
  state = {
    isChecked: false,
    isSuccess: false,
    name: "",
    specificInstructions: "",
    audience: null,
    conversationalStyle: null,
    language: null,
    files: [],
    isSubmit: false,
  };

  handleDropMultiFile = (acceptedFiles) => {
    const newFiles = acceptedFiles.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
      })
    );
    this.setState({ files: [...this.state.files, ...newFiles] });
  };
  handleRemoveFile = (inputFile) => {
    const filesFiltered = this.state.files.filter(
      (fileFiltered) => fileFiltered !== inputFile
    );
    this.setState({ files: filesFiltered });
  };
  handleRemoveAllFiles = () => {
    this.setState({ files: [] });
  };

  handleCreateBot = async () => {
    try {
      const res = await this.props.apiCallPost("/harley/createPersona", {
        name: this.state.name,
        instructions: this.state.specificInstructions,
        audience: this.state.audience,
        conversationalStyle: this.state.conversationalStyle,
        language: this.state.language,
        requiresTools: this.state.isChecked,
      });
      if (this.state.isChecked) {
        const fd = new FormData();
        fd.append("personaId", res._id);
        this.state.files.forEach((file, index) => {
          fd.append(`file${index}`, file);
        });
        try {
          const uploadedResults = await this.props.apiCallPostUpload(
            "/harley/attachFilesToPersona",
            fd,
            (uploadProgress) => {
              console.log("upload progress", uploadProgress);
            }
          );

          console.log("uploaddd", uploadedResults);
        } catch (error) {
          cogoToast.error("Error creating bot");
          this.setState({ isSuccess: false });
        }
      }
      this.setState({ isSuccess: true });

      cogoToast.success("Bot successfully created");

      console.log("res form create bot", res);
    } catch (error) {
      cogoToast.error("Error creating bot");
      this.setState({ isSuccess: false });
    }
  };
  render() {
    return (
      <Container>
        <Grid container sx={{ mb: 3 }}>
          <Grid
            item
            xs={6}
            alignItems={"start"}
            justifyContent={"start"}
            display={"flex"}
          >
            <Typography variant="h4">Create a Bot</Typography>
          </Grid>
        </Grid>

        <FormControl>
          <Box
            component="form"
            sx={{
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            <div>
              <TextField
                required
                id="outlined-required"
                label="Name"
                value={this.state.name}
                onChange={(item) => this.setState({ name: item.target.value })}
              />
            </div>
            <div>
              <FormControl sx={{ m: 1, minWidth: 245 }}>
                <TextareaAutosize
                  minRows={10}
                  label="Specific Instructions"
                  placeholder="Specific Instructions"
                  value={this.state.specificInstructions}
                  style={{ width: "100%", border: "solid 4px #FFFFFF" }}
                  onChange={(item) =>
                    this.setState({ specificInstructions: item.target.value })
                  }
                />
              </FormControl>
            </div>
            <div>
              <FormControl sx={{ m: 1, minWidth: 245 }}>
                <InputLabel id="demo-simple-select-helper-label">
                  Audience *
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  value={this.state.audience}
                  label="Audience"
                  onChange={(item) =>
                    this.setState({ audience: item.target.value })
                  }
                >
                  <MenuItem value={"PATIENT"}>Patient</MenuItem>
                  <MenuItem value={"DOCTOR"}>Doctor</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <FormControl sx={{ m: 1, minWidth: 245 }}>
                <InputLabel id="demo-simple-select-helper-label">
                  Conversational Style *
                </InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-helper-label"
                  id="demo-simple-select-helper"
                  label="Conversational Style"
                  value={this.state.conversationalStyle}
                  onChange={(item) =>
                    this.setState({ conversationalStyle: item.target.value })
                  }
                >
                  <MenuItem value={"FORMAL"}>Formal</MenuItem>
                  <MenuItem value={"INFORMAL"}>Informal</MenuItem>
                  <MenuItem value={"SERIOUS"}>Serious</MenuItem>
                  <MenuItem value={"ENGAGING"}>Engaging</MenuItem>
                  <MenuItem value={"HUMOROUS"}>Humorous</MenuItem>
                </Select>
              </FormControl>
            </div>

            <FormControl sx={{ m: 1, minWidth: 245 }}>
              <InputLabel id="demo-simple-select-helper-label">
                Language *
              </InputLabel>
              <Select
                required
                labelId="demo-simple-select-helper-label"
                id="demo-simple-select-helper"
                label="language"
                value={this.state.language}
                onChange={(item) =>
                  this.setState({ language: item.target.value })
                }
              >
                <MenuItem value={"ENGLISH"}>English</MenuItem>
                <MenuItem value={"MULTI_LINGUAL"}>Multi-lingual</MenuItem>
              </Select>
            </FormControl>
            <div>
              <FormControl sx={{ m: 1, minWidth: 245 }}>
                <FormControlLabel
                  required
                  control={<Checkbox />}
                  label="Requires tools"
                  checked={this.state.isChecked}
                  onChange={(item) => {
                    this.setState({ isChecked: item.target.checked });
                  }}
                />
              </FormControl>
            </div>
            {this.state.isChecked ? (
              <div>
                <FormControl sx={{ m: 1, minWidth: 245 }}>
                  <Upload
                    acceptedFileTypes={{
                      "text/csv": [".csv"],
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                        [".docx"],
                      "text/markdown": [".md"],
                      "application/pdf": [".pdf"],
                      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                        [".pptx"],
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                        [".xlsx"],
                      "application/zip": [".zip"],
                      "text/xml": [".xml"],
                      "text/plain": [".txt"],
                      "application/json": [".json"],
                    }}
                    thumbnail={false}
                    multiple
                    files={this.state.files}
                    onDrop={this.handleDropMultiFile}
                    onRemove={this.handleRemoveFile}
                    onRemoveAll={this.handleRemoveAllFiles}
                    // onUpload={() => this.uploadMultipleFiles()}
                  />
                </FormControl>
              </div>
            ) : null}

            <FormControl sx={{ m: 1, minWidth: 245 }}>
              {this.state.isSuccess ? (
                <Button
                  variant="contained"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({
                      name: "",
                      specificInstructions: "",
                      audience: null,
                      conversationalStyle: null,
                      language: null,
                      files: [],
                      isChecked: false,
                    });
                  }}
                >
                  Reset
                </Button>
              ) : (
                <Button
                  type="submit"
                  variant="contained"
                  disabled={this.state.isSubmit}
                  onClick={(e) => {
                    this.setState({ isSubmit: true });
                    e.preventDefault();
                    this.handleCreateBot(e);
                  }}
                >
                  Create Bot
                </Button>
              )}
            </FormControl>
          </Box>
        </FormControl>
      </Container>
    );
  }
}

export default WithAPICall(BotCreator);
